import { formatBooleanValue } from "../../util";
import IndexTypeAttribute from "../model/IndexTypeAttribute";

const IndexTypeAttributeMapper = (item: any) => {
  let indexTypeAttribute = IndexTypeAttribute(item);
  indexTypeAttribute.required = formatBooleanValue(item.required);
  indexTypeAttribute.valid = formatBooleanValue(item.valid);
  return indexTypeAttribute;
};

export default IndexTypeAttributeMapper;
